var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"product-placement-add-modal",attrs:{"cancel-variant":"outline-secondary","size":"lg","centered":"","title":"Add component","hide-footer":""}},[_c('AddPlacementComponent',{on:{"created":_vm.created}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }